import { http } from '@/api/http';

/**
 * One detected term span inside a free-text narrative. Mirrors the BE
 * Text Mining annotation contract — to-be-defined; see PTV2-1051 #5.
 *
 * `start` / `end` are character offsets into the source narrative;
 * `snippet` is the supporting fragment shown next to the suggestion.
 * `termId` carries the HPO or OMIM id; `vocabulary` lets the UI route
 * Accept to the right structured section.
 */
export interface NarrativeAnnotation {
  readonly start: number;
  readonly end: number;
  readonly snippet: string;
  readonly termId: string;
  readonly label: string;
  readonly vocabulary: 'hpo' | 'omim';
}

export interface AnnotateNarrativeBody {
  readonly text: string;
}

/**
 * POST /text-mining/annotate — detect HPO / OMIM term mentions in free
 * text. The Phase 1 BE endpoint isn't built yet (PTV2-1051 #5); the
 * call site gates this behind the `narrativeNlp` feature flag so the
 * code path stays dormant until the BE lands. Once it does, no FE
 * changes are needed — just flip the flag.
 *
 * Returns an empty list on any error so the suggestion panel
 * gracefully degrades rather than blocking the narrative edit.
 */
export async function annotateNarrative(
  body: AnnotateNarrativeBody,
  options?: { signal?: AbortSignal },
): Promise<readonly NarrativeAnnotation[]> {
  try {
    const response = await http.post<{ annotations?: readonly NarrativeAnnotation[] }>(
      '/text-mining/annotate',
      body,
      options,
    );
    return response.annotations ?? [];
  } catch {
    return [];
  }
}
